import Vuex from 'vuex';

const state = {
  isOpened: false,
  height: 0,
  currentNavigation: null
};

const getters = {
  isSecondNavigationOpened: (state, getters, rootState) => {
    return state.isOpened;
  },
  secondNavigationStyles: (state, getters, rootState) => {
    if(['lap', 'desktop'].includes(rootState.mediaqueries.currentMediaQueryName)) {
      return {
      };
    }
    return {
      'max-height': `${state.isOpened ? state.height : 0 }px`
    }
  },
  hasCurrentNavigation: (state, getters, rootState) => {
    return state.currentNavigation != null;
  },
};

const actions = {
  setShowSecondNavigation: ({ state, commit }, open) => {
    commit('changeShowNavigation', { open });
  },
  toggleSecondNavigationMenu: ({ state, commit }) => {
    commit('changeOpenState');
    if(!state.isOpened && state.currentNavigation) {
      commit('changeCurrentNavigationOpenState', { isOpened: false });
      commit('changeCurrentNavigationState', { currentNavigation: null });
    }
  },
  setShowCurrentItem: ({ state, commit }, open) => {
      commit('changeShowCurrentItemState', { open });
  },
  setSecondNavigationHeight: ({ state, commit }, height) => {
    commit('changeHeightState', { height });
  },
  setCurrentNavigation: ({ state, commit, dispatch }, currentNavigation) => {

    //If current subnavigation is opened then close it and opened the new one
    if(state.currentNavigation && state.currentNavigation != currentNavigation) {
      commit('changeShowCurrentItemState', { open: false });
      commit('changeCurrentNavigationState', { currentNavigation });

      //If click on the same sub navigation then close it
    } else if (state.currentNavigation && state.currentNavigation == currentNavigation) {
      currentNavigation = null;
      commit('changeCurrentNavigationState', { currentNavigation });

      //Set current navigation
    } else {
      commit('changeCurrentNavigationState', { currentNavigation });
    }
  }
};

const mutations = {
  changeHeightState: (state, { height }) => {
    state.height = height;
  },
  changeOpenState: (state) => {
    state.isOpened = !state.isOpened;
  },
  changeCurrentNavigationState: (state, {currentNavigation }) => {
    state.currentNavigation = currentNavigation;
  },
  changeShowCurrentItemState: (state, { open }) => {
    if(state.currentNavigation) {
      state.currentNavigation.isOpened = open;
    }
  },
  changeCurrentNavigationOpenState: (state, { isOpened }) => {
    if(state.currentNavigation) {
      state.currentNavigation.isOpened = isOpened;
    }
  },
  changeShowNavigation: (state, { open }) => {
    state.isOpened = open;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./store/modules/secondnavigation.js